
  module.exports =
  {

    toIssue:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    toIssueList:
    {

      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#signups', 'MiFi', 'toIssueList')

        $('#priority').not('.js-ignore').click(function ()
        {
          APPLICATION._APPLICATION.load($('#signups'), APPLICATION._PATH_PREFIX + 'mi-fi/to-issue-list?priority=1', 'MiFi', 'toIssueList')
        }
        ).addClass('js-ignore')

        $('#week1').not('.js-ignore').click(function ()
        {
          APPLICATION._APPLICATION.load($('#signups'), APPLICATION._PATH_PREFIX + 'mi-fi/to-issue-list', 'MiFi', 'toIssueList')
        }
        ).addClass('js-ignore')

        $('#overdue').not('.js-ignore').click(function ()
        {
          APPLICATION._APPLICATION.load($('#signups'), APPLICATION._PATH_PREFIX + 'mi-fi/to-issue-list?overdue=1', 'MiFi', 'toIssueList')
        }
        ).addClass('js-ignore')

        $('#total').not('.js-ignore').click(function ()
        {
          APPLICATION._APPLICATION.load($('#signups'), APPLICATION._PATH_PREFIX + 'mi-fi/to-issue-list?total=1', 'MiFi', 'toIssueList')
        }
        ).addClass('js-ignore')

      }

    },

    issue:
    {

      _init: function ()
      {

        $('#mifi_recipient_id').not('.js-ignore').change(function ()
        {

          if ($(this).val() === $('#recipient_other').val())
          {
            $('#address').show()
          }

          else
          {
            $('#address').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

      }

    },

    devices:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    devicesList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#devices', 'MiFi', 'devicesList')
      }

    },

    connections:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    connectionsList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#connections', 'MiFi', 'connectionsList')
      }

    },

    packages:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    packagesList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#packages', 'MiFi', 'packagesList')
      }

    },

    issued:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    issuedList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#issued', 'MiFi', 'issuedList')
      }

    },

    recharges:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    rechargesList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#packages', 'MiFi', 'rechargesList')
      }

    },

    history:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    historyList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#history', 'MiFi', 'historyList')
      }

    },

    removed:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.search($('.js-url'))
      }

    },

    removedList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#removed', 'MiFi', 'removedList')
      }

    }

  }